import { RouterInput, ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { useMindlerApi } from "./apiv2";

export const useGetAllSlotData = (
  args: RouterInput["statistics"]["getAllSlotsByPsychologistId"],
) => {
  const mindlerApi = useMindlerApi();
  return useQuery(
    mindlerApi.statistics.getAllSlotsByPsychologistId.queryOptions(args),
  );
};
